import type { AcademyAnnouncementBanner } from '~/generated_types';
import type { AcademyAnnouncementBannerThemeSettings } from '../../types';
import { useQuery } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { academyAnnouncementBannerKeys } from './academyAnnouncementBannerKeyFactory';

type AcademyAnnouncementBannerForAdmin = AcademyAnnouncementBanner['ADMIN'];
interface AcademyAnnouncementBannerForAdminWithTheme extends AcademyAnnouncementBannerForAdmin {
  themeSettings: AcademyAnnouncementBannerThemeSettings;
}

function getAcademyAnnouncementBanners(academyId: string): Promise<AcademyAnnouncementBannerForAdminWithTheme[]> {
  return FetchPromise.get(`academies/${academyId}/academy_announcement_banners`);
}

export function useGetAcademyAnnouncementBannersQuery(academyId, queryOptions = {}) {
  return useQuery<AcademyAnnouncementBannerForAdminWithTheme[], JQuery.jqXHR>({
    queryKey: academyAnnouncementBannerKeys.academyAnnouncementBanners(academyId),
    queryFn: () => getAcademyAnnouncementBanners(academyId),
    ...queryOptions,
  });
}
